/* eslint-disable max-len */
import React, {useState, useEffect} from 'react'
import Helpers from '../Helpers'
import {storePayload} from '../actions/storePayload'
import {connect} from 'react-redux'
import Chat2 from './Chat2'
import '../styles/Workflow.css'

function ChatSection(props) {
  const [chatPrompts, setChatPrompts] = useState([])
  const [localSelectedSubSectionName, setLocalSelectedSubSectionName] = useState(null)
  const [context, setContext] = useState()

  useEffect(() => {
    if (
      props.selectedSubSectionName &&
      props.selectedSubSectionName !== localSelectedSubSectionName
    ) {
      setLocalSelectedSubSectionName(props.selectedSubSectionName)
    }
  }, [props.selectedSubSectionName])

  useEffect(() => {
    if (localSelectedSubSectionName) {
      const context =
      `Context: The user is currently on the ${localSelectedSubSectionName} page of the capability and needs statement. Your job is to assist them with answering any questions that they might have.`
      setContext(context)
      addContextToChat(context)
      // console.log('setting chat context', context)
    }
  }, [localSelectedSubSectionName])

  useEffect(() => {
    if (props.chatHistory) {
      // set array of questions/answers to render in <Chat />
      const userQuestions = []
      const aiAnswers = []
      props.chatHistory.forEach((line) => {
        if (line.role === 'user') {
          userQuestions.push(line.content)
        } else {
          aiAnswers.push(line.content)
        }
      })
      // setUserQuestions(userQuestions)
      // setAiAnswers(aiAnswers)
      const chatPrompts = []
      userQuestions.forEach((line, i) => {
        if (line && line.slice(0, 33) !== context?.slice(0, 33)) {
          chatPrompts.push(
              {
                id: '',
                title: Helpers.truncateString(line, 35),
                questions: [line],
                answers: [aiAnswers[i]],
              },
          )
        }
      })
      setChatPrompts(chatPrompts)
    }
  }, [props.chatHistory])

  useEffect(() => {
    const scrollView = document.getElementById('_2I--s')
    if (scrollView) {
      setTimeout(() => {
        // scrollView.scrollTop = scrollView.scrollHeight
        scrollView.scrollTo({
          top: scrollView.scrollHeight,
          behavior: 'smooth',
        })
      }, 100)
    }
  }, [chatPrompts])

  function addContextToChat(context) {
    // Add in fake (and hidden) chat history before user question to steer prompt
    const newChatHistory = [
      ...props.chatHistory,
      {role: 'user', content: context},
      {role: 'assistant', content: 'Understood! How can I help?'},
    ]
    props.storePayload({
      chatHistory: newChatHistory,
    })
  }

  function onChangeQuestion(e) {
    props.storePayload({
      question: e.target.value,
    })
  }

  function onSubmit(e) {
    e.preventDefault()
    const question = props.question
    props.storePayload({
      question: '',
      isLoading: true,
    })
    let prompt
    if (props.chatHistory) {
      // Hack to avoid too many quesitons bug
      const limit = 2
      const beginningIndex =
        props.chatHistory.length - limit < 0 ? 0 : props.chatHistory.length - limit
      const truncatedHistory =
        props.chatHistory.slice(beginningIndex, props.chatHistory.length)
      // console.log('truncated history', truncatedHistory)
      prompt = [
        ...truncatedHistory,
        {role: 'user', content: question},
      ]
    } else {
      prompt = [
        // {role: 'user', content: context},
        // {role: 'assistant', content: 'Understood! How can I help?'},
        {role: 'user', content: question},
      ]
    }

    // console.log('prompt', prompt)
    Helpers.fetchPostJson(
        process.env.REACT_APP_API_URL + '/chat_bot',
        {chat: prompt},
        {authKey: process.env.REACT_APP_CHAT_AUTH_KEY},
    )
        .then((res) => {
          props.storePayload({
            chatHistory: res['chat_history'],
            chatResponse: res['chat_response'],
          })
        })
        .catch((err) => {
          console.log('Error: ', err)
          props.storePayload({
            userMessage: 'Error: Alfred chat cannot currently handle a prompt of that length.',
            notificationIcon: 'warning',
            notificationType: 3,
          })
        })
        .finally(() => {
          props.storePayload({
            isLoading: false,
          })
        })
  }
  return (
    <div
      id='chat-container'
      className={
        `chat-container
        ${props.isChatShowing ? 'open-chat' : 'closed-chat'}`
      }
    >
      <Chat2
        title='Alfred'
        feedTitle='chat'
        hasInput={true}
        style={{width: '100%', height: '100%'}}
        newPrompt={props.question}
        newPromptPlaceholder='Enter a prompt...'
        onChangeNewPrompt={onChangeQuestion}
        onSubmitPrompt={onSubmit}
        prompts={chatPrompts}
        theme='dark'
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  isChatShowing: state.userReducer.isChatShowing,
  chatHistory: state.userReducer.chatHistory,
  chatResponse: state.userReducer.chatResponse,
  question: state.userReducer.question,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(ChatSection)
